import { motion } from "framer-motion";
import { Play, ArrowRight, Download, BellOff, Banknote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  { icon: Download, text: "Two-minute setup on any device" },
  { icon: BellOff, text: "Runs silently — nothing to click, ever" },
  { icon: Banknote, text: "Cash out via PayPal or crypto" },
];

const VideoSection = ({ onJoin }) => (
  <section id="demo" data-testid="video-section" className="py-20 sm:py-28 honey-grain">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal className="order-2 lg:order-1 flex justify-center">
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.3 }}
          className="relative rounded-[2rem] overflow-hidden border-8 border-zinc-900 shadow-2xl shadow-amber-900/20 bg-zinc-900 w-full max-w-xl"
        >
          <video
            data-testid="demo-video"
            src="/hero-reel.mp4"
            autoPlay
            muted
            loop
            playsInline
            controls
            className="w-full aspect-video object-cover"
          />
        </motion.div>
      </Reveal>

      <Reveal delay={0.1} className="order-1 lg:order-2">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-700 inline-flex items-center gap-2">
          <Play className="w-4 h-4" /> See it in action
        </p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-900 max-w-lg">
          Watch how effortless earning looks
        </h2>
        <p className="mt-4 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-lg">
          No surveys, no tasks, no daily check-ins. This is the whole product: install it once and
          your balance grows while you get on with your day.
        </p>
        <ul className="mt-7 space-y-3.5">
          {POINTS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-base font-medium text-zinc-700">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-amber-100 border border-amber-200 text-amber-700 shrink-0">
                <Icon className="w-4.5 h-4.5 w-5 h-5" />
              </span>
              {text}
            </li>
          ))}
        </ul>
        <button
          data-testid="video-join-button"
          onClick={() => onJoin("video_section")}
          className="group mt-8 inline-flex items-center gap-2.5 rounded-full bg-amber-400 px-8 py-4 font-display text-base font-bold text-zinc-900 shadow-[0_12px_30px_-10px_rgba(245,158,11,0.6)] hover:bg-amber-300 transition-colors"
        >
          Try It Free — Get $3
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default VideoSection;
